import { Grid } from "@mui/material";
import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import { GetPaymentSettlmentInfoResponse } from "../../../models/supplierPayment.model";
export default function DetailInfo_settlementRegister({
  detailInfo,
}: {
  detailInfo: GetPaymentSettlmentInfoResponse;
}) {
  return (
    <div
      className={"mTop30"}
      style={{
        width: "100%",
        margin: "-2vh auto 3vh",
        background: "#F9FAFC",
        paddingBottom: "2vh",
        border: "1px solid #DAE0E4",
        borderRadius: "5px",
      }}
    >
      <span
        className="colorTitle fontWeight textFont16 mbottom10"
        style={{
          marginTop: "-13px",
          marginRight: "20px",
          paddingRight: "5px",
          paddingLeft: "5px",
          display: "block",
          background: "#fff",
          width: "285px",
          borderRadius: "10px",
          height: "18px",
        }}
      >
        <PersonIcon />
        &nbsp; مشخصات ثبت کننده درخواست تسویه
      </span>

      <div
        className="cardBorderTitle borderCOlor"
        style={{ borderBottom: "1px solid #DAE0E4", margin: "5px 35px" }}
      >
        <Grid
          item
          xs={12}
          container
          style={{ lineHeight: "3vh", marginTop: "20px", marginBottom: "15px" }}
        >
          <Grid item xs={4} md={3} style={{ padding: "5px" }}>
            <span style={{ color: "#9AAFC4" }}>نام و نام خانوادگی:&nbsp;</span>
            <b style={{ color: "#34495E" }}> {detailInfo.creatorUserTitle} </b>
          </Grid>
          <Grid item xs={4} md={3} style={{ padding: "5px" }}>
            <span style={{ color: "#9AAFC4" }}> تاریخ و ساعت ایجاد:&nbsp;</span>
            <b style={{ color: "#34495E" }}> {detailInfo.createPersianDate} </b>
          </Grid>
          <Grid item xs={4} md={3} style={{ padding: "5px" }}>
            <span style={{ color: "#9AAFC4" }}> نوع تسویه:&nbsp;</span>
            <b style={{ color: "#34495E" }}>
              {" "}
              {detailInfo.settlementTypeTitle}
            </b>
          </Grid>
          <Grid item xs={4} md={3} style={{ padding: "5px" }}>
            <span style={{ color: "#9AAFC4" }}> مبلغ تسویه:&nbsp;</span>
            <b style={{ color: "#34495E" }}>
              {" "}
              {detailInfo.settlementAmount?.toLocaleString("fa")} ریال
            </b>
          </Grid>
        </Grid>
      </div>
      <Grid
        xs={12}
        container
        style={{
          lineHeight: "3vh",
          marginTop: "20px",
          marginBottom: "15px",
          marginRight: "15px",
        }}
      >
        <Grid
          container
          xs={12}
          style={{
            marginRight: "25px",
            marginLeft: "25px",
          }}
        >
          <Grid item xs={2} style={{ maxWidth: "fit-content" }}>
            <span style={{ color: "#9AAFC4" }}> توضیحات:&nbsp;</span>
          </Grid>
          <Grid item xs={11}>
            <b style={{ color: "#34495E", marginRight: "5px" }}>
              {detailInfo.creatorDescription}
            </b>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
